export default [
  {
    name: 'Accueil',
    icon: 'nc-icon nc-alert-circle-i',
    path: '/overview',
  },
  {
    name: 'Personnes',
    icon: 'nc-icon nc-single-02',
    path: '/people',
  },
  {
    name: 'Institutions',
    icon: 'nc-icon nc-bank',
    path: '/institutions',
  },
  {
    name: 'Commissions',
    icon: 'nc-icon nc-chat-33',
    path: '/committees',
  },
  {
    name: 'Listes',
    icon: 'nc-icon nc-bullet-list-67',
    path: '/customLists',
  },
  {
    name: 'Données de base',
    icon: 'nc-icon nc-box',
    children: [
      {
        name: 'Cantons',
        path: '/data/cantons',
      },
      {
        name: 'Fonctions',
        path: '/data/functions',
      },
      {
        name: 'Moyens de communication',
        path: '/data/meansOfTelecom',
      },
      {
        name: 'Pays',
        path: '/data/countries',
      },
      {
        name: 'Rôles',
        path: '/data/roles',
      },
      {
        name: 'Rôles Bureaux',
        path: '/data/rolesOffice',
      },
      {
        name: "Types d'adresses",
        path: '/data/addressTypes',
      },
      {
        name: 'Thèmes',
        path: '/data/profiles',
      },
    ],
  },
];
